import type { FC, PropsWithChildren, ReactNode } from 'react';

import Header from '@zen/Layout/Header';

import PageContent from '../PageContent';
import type { ContentWidth } from '../PageContent/PageContent';
import PageTitle from '../PageTitle';

interface Props {
  tagline: ReactNode;
  title: string;
  width?: ContentWidth;
}

const LandingPage: FC<PropsWithChildren<Props>> = ({ children, title, tagline, width = 'narrower', ...rest }) => (
  <div className="flex flex-col min-h-screen bg-white" {...rest}>
    <Header isLogoLinked={false} />
    <div className="flex justify-center flex-1 w-full pt-16">
      <PageContent width={width}>
        <PageTitle className="mb-8" tagline={tagline} title={title} />
        {children}
      </PageContent>
    </div>
  </div>
);

export default LandingPage;
